import React from 'react';
import ReceptionFeedbackDispatchPage from './ReceptionFeedbackDispatchPage';

export default function CounterReceptionFeedbackPage() {
  return (
    <ReceptionFeedbackDispatchPage />
  );
}
